module.exports = __webpack_public_path__ + "static/media/question.69b66d69.png";